import { AlertCircle, Refresh } from '@saleshandy/icons';
import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { accessibleOnClick } from '../../../../../shared/utils/accessible-on-click';
import { resetAiColumnTemplateRegenerate } from '../../../prospect-slice';

const DiscardUnsavedChangesModal = ({
  show,
  onDiscard,
  onHide,
  text = 'Are you sure you want to close without saving? You will lose all unsaved progress.',
  isSingleCellRegeneration = false,
}) => {
  const dispatch = useDispatch();
  return (
    <Modal
      show={show}
      onHide={onHide}
      backdrop="static"
      centered
      className="discard-unsaved-changes-modal"
    >
      <div className="discard-unsaved-changes-modal-container">
        <div className="discard-unsaved-changes-modal-content">
          <div className="discard-unsaved-changes-modal-header">
            <div className="header-title">
              {isSingleCellRegeneration ? <Refresh width={24} height={24} color="#1F2937" /> : <AlertCircle width={24} height={24} color="#D97706" />}
              <span className="line-height-1">{isSingleCellRegeneration ? 'Conditions Not Met' : 'Discard Unsaved Changes'}</span>
            </div>
          </div>
          <div className="discard-unsaved-changes-modal-body">
            <span className="discard-unsaved-changes-modal-text">{text}</span>
          </div>
        </div>
        <div className="divider-line" />
      </div>
      <div className="discard-unsaved-changes-modal-footer">
        <div className="cancel-button" {...accessibleOnClick(onHide)}>
          {isSingleCellRegeneration ? 'Keep Current' : 'No, keep editing'}
        </div>
        <div
          className="discard-btn"
          {...accessibleOnClick(() => {
            dispatch(resetAiColumnTemplateRegenerate());
            onDiscard();
          })}
        >
          <Button>{isSingleCellRegeneration ? 'Yes, Regenerate' : 'Yes, discard'}</Button>
        </div>
      </div>
    </Modal>
  );
};

export default DiscardUnsavedChangesModal;